import { clsx } from "clsx";
import { Check } from "lucide-react";

interface OnboardingStepperProps {
	steps: string[];
	current: number;
}

export function OnboardingStepper({ steps, current }: OnboardingStepperProps) {
	return (
		<ol className="onboarding-stepper">
			{steps.map((label, index) => {
				const done = index < current;
				const active = index === current;
				const isLast = index === steps.length - 1;
				return (
					<li
						key={label}
						className={clsx("onboarding-stepper__item", !isLast && "is-grow")}
					>
						<span
							className="onboarding-stepper__dot"
							data-state={done ? "done" : active ? "active" : "todo"}
						>
							{done ? <Check /> : index + 1}
						</span>
						<span
							className={clsx(
								"onboarding-stepper__label",
								active && "is-active",
							)}
						>
							{label}
						</span>
						{!isLast && (
							<span
								className={clsx(
									"onboarding-stepper__connector",
									done && "is-done",
								)}
							/>
						)}
					</li>
				);
			})}
		</ol>
	);
}
